// Home-screen install detection.
//
// Why this exists: on iOS, Web Push (and even the Notification/PushManager APIs) is only
// available once the PWA is installed to the Home Screen. So an iPhone visitor in a normal
// Safari tab can never receive turn alerts until they install. We detect that state and walk
// them through it. Android already supports push in a browser tab, so it is left alone.

export type MobilePlatform = "ios" | "android";

/** True when launched from the Home Screen / as an installed PWA (any platform). */
export function isStandalone(): boolean {
  if (typeof navigator === "undefined") return false;
  const iosStandalone = "standalone" in navigator && (navigator as unknown as { standalone?: boolean }).standalone === true;
  return iosStandalone || window.matchMedia("(display-mode: standalone)").matches;
}

/** The mobile platform we can offer install instructions for, or null (desktop / unknown). */
export function mobilePlatform(): MobilePlatform | null {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return "android";
  if (/iphone|ipod/i.test(ua)) return "ios";
  // iPadOS 13+ reports a Mac user agent; fingerprint it by touch support.
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) return "ios";
  return null;
}
